/**
 * Homepage selectors
 */


import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './slice';
import { RootState } from 'types/RootState';

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state.gamesSelectState || initialState;

export const selectGames = createSelector(
  [selectDomain],
  select => select.games,
);

export const selectPagination = createSelector(
    [selectDomain],
    select => select.pagination,
);

export const selectIsLoading = createSelector(
    [selectDomain],
    select => select.isLoading,
);
